import { render } from "./SubtituloInput.vue?vue&type=template&id=24b5e4ab&scoped=true&ts=true"
import script from "./SubtituloInput.vue?vue&type=script&lang=ts"
export * from "./SubtituloInput.vue?vue&type=script&lang=ts"

import "./SubtituloInput.vue?vue&type=style&index=0&id=24b5e4ab&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5e4ab"]])

export default __exports__